<template>
  <div class="card shadow p-3">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">
            {{ title }}
          </h3>
        </div>
      </div>
    </div>

    <b-row>
      <b-col md="12" class="table-responsive">
        <b-table
          class="align-items-center table-flush tablesorter table-text"
          hover
          :items="tableData.data"
          :fields="columns"
          :per-page="perPage"
          :current-page="currentPage"
          :busy="
            !Array.isArray(tableData.data) || tableData.data.length === 0
              ? true
              : false
          "
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <span class="h2 text-danger">{{ $t("fail") }}</span>
            </div>
          </template>
          <template v-slot:cell(created_at)="data">
            {{moment(data.item.created_at).format('DD-MM-YYYY HH:mm')}} hrs.
          </template>
           <template v-slot:cell(claimed_at)="data">
            <div v-if="data.item.claimed_at">
            {{moment(data.item.claimed_at).format('DD-MM-YYYY HH:mm')}} hrs.
            </div>
          </template>
           <template v-slot:cell(claimed)="data">
            <b-badge
              class="text-white"
              size="lg"
              style="font-size: 10px"
              :class="data.item.is_claimed ? 'bg-success' : 'bg-danger'"
              >{{
                data.item.is_claimed ? $t('yes') : $t('not')
              }}</b-badge
            >
          </template>
        </b-table>
        <b-pagination
          class="mt-3"
          v-model="tableData.current_page"
          :total-rows="tableData.total"
          :per-page="tableData.per_page"
          :page-count="tableData.per_page"
          @input="changePage"
          first-number
          pills
          size="sm"
          align="center"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from 'moment'
export default {
  props: {
    title: String,
  },
  async created() {
    await this.getData({
      currentPage: 1,
      perPage: this.perPage,
      company_id: this.modal ? this.$route.params.id : null,
    });
    this.debouncedGetAnswer = _.debounce(this.search, 500);
    console.log(this.tableData)
  },
  watch: {
    searchData() {
      this.debouncedGetAnswer();
    },
    async perPage() {
      await this.changePerPage();
    },
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      searchData: "",
      moment
    };
  },
  methods: {
    ...mapActions({
      getUsersRewards: "getUsersRewards",
    }),
    async search() {
      await this.getData({
        currentPage: this.currentPage,
        perPage: this.perPage,
        search: this.searchData,
        company_id: this.modal ? this.$route.params.id : null,
      });
    },
    async changePage(value) {
      await this.getData({
        currentPage: value ? value : this.currentPage,
        perPage: this.perPage,
        company_id: this.modal ? this.$route.params.id : null,
      });
    },
    async changePerPage() {
      await this.getData({
        currentPage: this.currentPage,
        perPage: this.perPage,
        company_id: this.modal ? this.$route.params.id : null,
      });
    },
    async getData(data){
       await this.getUsersRewards(data);
    }
  },
  computed: {
    ...mapGetters({
      tableData: "getUsers",
    }),
    columns() {
      return [
        { label: this.$t("name"), key: "user.name", class: "text-center" },
        { label: this.$t("lastname"), key: "user.lastname", class: "text-center" },
        { label: this.$t("email"), key: "user.email", class: "text-center" },
        // { label: this.$t("reward_for"), key: "type_name", class: "text-center" },
        { label: this.$t("date"), key: "created_at", class: "text-center" },
        { label: this.$t("claimed"), key: "claimed", class: "text-center" },
        { label: this.$t("claimed_date"), key: "claimed_at", class: "text-center" },

      ];
    },
  },
};
</script>

